// CIAO-FOOD – Rotation für Geschmack-Badges (nur Mobile)
document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  if (!isMobile) return;

  document.querySelectorAll(".product-geschmack-container").forEach(container => {
    // Bevorzugt die Mobile-Zone, sonst den Container direkt
    const scope = container.querySelector(".only-mobile") || container;
    const items = Array.from(scope.querySelectorAll(".product-geschmack, .cf-taste-badge"))
      .filter(el => el.textContent.trim() !== "");

    if (items.length <= 1) return;

    let i = 0;
    items.forEach((el, idx) => el.style.display = idx === 0 ? "inline-flex" : "none");

    setInterval(() => {
      items[i].style.display = "none";
      i = (i + 1) % items.length;
      items[i].style.display = "inline-flex";
    }, 3000);
  });
});
